import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=5d0543ba&scoped=true"
import script from "./password-reset.vue?vue&type=script&lang=js"
export * from "./password-reset.vue?vue&type=script&lang=js"
import style0 from "./password-reset.vue?vue&type=style&index=0&id=5d0543ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0543ba",
  null
  
)

export default component.exports